module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_orange.dee3e087.svg";